import { render } from "./EndGamePage.vue?vue&type=template&id=7c5bfb1a&scoped=true"
import script from "./EndGamePage.vue?vue&type=script&lang=js"
export * from "./EndGamePage.vue?vue&type=script&lang=js"

import "./EndGamePage.vue?vue&type=style&index=0&id=7c5bfb1a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5bfb1a"]])

export default __exports__